import * as React from 'react'
import * as Tgcc from '../tgccGlobal'
import {browserHistory} from 'react-router'
import {connect} from 'react-redux'
import {ScreenDoor} from './ScreenDoor'
import {CloseX} from './CloseX'
import * as Request from '../tgccRequest'
import Radium, { StyleRoot } from 'radium'


const boxStyle: React.CSSProperties = {
    height: '320px',
    width: '568px',
    position: 'relative',
    top: '50%',
    marginTop: '-180px',
    left: '50%',
    marginLeft: '-284px',
    backgroundColor: 'white',
    fontFamily: 'CenturyGothic',
    textTransform: 'uppercase',
    display: 'flex',
    flexDirection: 'column',
    borderRadius:'10px',
    justifyContent: 'space-around',
};

const rowStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    width: '75%',
    height: '30px',
    alignItems: 'center',
    margin:'10px auto'
}

const lblStyle: React.CSSProperties = {
    color: Tgcc.Styles.darkTextColor,
    height: '25px',
    lineHeight: '25px',
    fontSize: '18px',
    marginRight: '8px',
    flexGrow: 0,
    fontFamily:'Lulo',
}

const inputStyle: React.CSSProperties = {
    border: '1px solid black',
    height: '25px',
    lineHeight: '25px',
    padding: '0 4px',
    fontSize: '16px',
    flexGrow: 1,
    fontFamily:'BarlowLight'
}

const workStyle: React.CSSProperties = {
    verticalAlign: 'middle',
    width: '44px',
    alignSelf: 'center',
    filter: 'grayscale(90%)'
}

let forgotRowStyle = Object.assign({}, rowStyle, {justifyContent: 'flex-end', height: 'auto', margin: '-10px auto 10px auto'})
const forgotLinkStyle: React.CSSProperties = {
    display: 'flex',
    alignSelf: 'flex-end',
    fontSize: '11px',
    padding: '2px',
    fontFamily:'BarlowLight'
}
const loginTxt: React.CSSProperties = {
    color:'white',
    textAlign:'center',
    marginTop:'34px',
    width:'100%',
    fontSize:'32px',
    fontFamily:'BarlowLight'
}
const gcLogo: React.CSSProperties = {
    width:'106px',
    height:'111px'
}
const loginTop: React.CSSProperties = {
    position:'relative',
    top:'50px',
    left:'50%',
    height:'111px',
    width:'106px',
    cursor:'pointer',
    marginLeft:'-53px'
}
const submitBtn: React.CSSProperties = {
    border: '1px solid transparent',
    backgroundColor: '#E27558',
    height: '35px',
    lineHeight: '35px',
    fontSize: '15px',
    padding: '0 25px',
    textAlign: 'center',
    textTransform: 'uppercase',
    color: 'white',
    alignSelf: 'center',
    cursor: 'pointer',
    margin: '10px 0',
    fontFamily:'Lulo'
}
const arrowStyle: React.CSSProperties = {
    width:'8%',
    display:'inline-block'
}

const bottomDiv: React.CSSProperties = {
    textAlign:'center',
    backgroundColor: '#E9E6E6',
    height:'105px',
    borderBottomLeftRadius:'10px',
    borderBottomRightRadius:'10px',
    cursor:'pointer',
    marginBottom:'-10px'
}
const newGC: React.CSSProperties = {
    marginTop:'15px',
    fontFamily:'Lulo',
    color:'#616060'
}
const outerDiv: React.CSSProperties = {
    backgroundColor:'#616060',
    height:'100%'
}
const createAcc: React.CSSProperties = {
    display:'inline-block',
    fontFamily:'BarlowLight',
    color:'#616060'
}
class _CampusLogin extends React.Component<Tgcc.BaseProps, any> {
    state: any = {
        error: "",
        email: "",
        password: "",
        isWaiting: false,
        returnUrl: null, // Add returnUrl to the state
        // OTP modal state for passwordless login
        showOtp: false,
        otpCode: '',
        otpError: '',
        resendCountdown: 0,
        isResending: false
    };

    openRegister = () =>{browserHistory.push(Tgcc.Routes.CampusRegister)};
    openHome = () =>{browserHistory.push(Tgcc.Routes.Campus)};

    componentDidMount(){
        var tag = document.getElementById('campusLogin');
        tag.scrollIntoView(false);
        
         // Check for a returnUrl query parameter
        const searchParams = new URLSearchParams(window.location.search);
        const returnUrl = searchParams.get('returnUrl');
        if (returnUrl) {
            this.setState({ returnUrl: decodeURIComponent(returnUrl) });
        }

    }

    componentWillUnmount() {
        // Clear the OTP timer to prevent memory leaks
        clearInterval((this as any)._loginOtpTimer);
    }
    
    scrollPageToView = (id: string) => {
        var el = document.getElementById(id);
        var scroller = document.getElementById("Scroller");
        scroller.scrollTop = el.offsetTop - 75;
    }
    cancelLogin = () => {
        this.setState({isWaiting: false});
        this.props.dispatch({type: Tgcc.StateAction.DialogAction, payload: null})
    }

    failedLogin = (err: any) => {
        this.setState({isWaiting: false, error: err});
    }

    doLogin = () => {
        console.log('logging in...');
        if (!this.state.email) { this.setState({ error: 'Email cannot be blank' }); return; }
        // Passwordless path: request OTP then show modal (password field removed from UI)
        this.setState({ isWaiting: true, otpError: '' });
        Request.requestLoginOtp(this.state.email,
            (_res) => {
                const wait = _res && _res.resendAfterSeconds ? _res.resendAfterSeconds : 60;
                this.startResendCountdown(wait);
                this.setState({ isWaiting: false, showOtp: true });
            },
            (err: string) => this.setState({ isWaiting: false, error: err })
        );
    };
    

    emailChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        evt.stopPropagation();
        this.setState({email: evt.currentTarget.value});
    }

    passwordChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        evt.stopPropagation();
        this.setState({password: evt.currentTarget.value});
    }

    keyPressed = (evt: React.KeyboardEvent<HTMLInputElement>) => {
        if(evt.key === 'Enter')
            this.doLogin();
    }

    forgotPassword = () => {
        this.props.dispatch({type: Tgcc.StateAction.DialogAction, payload: {action: Tgcc.DialogAction.CampusForgotPassword, payload: {email: this.state.email}}});
    }

    // OTP helpers
    startResendCountdown = (seconds: number) => {
        clearInterval((this as any)._loginOtpTimer);
        ;(this as any)._loginOtpTimer = setInterval(() => {
            this.setState((prev: any) => {
                const next = (prev.resendCountdown || 0) - 1;
                if (next <= 0) {
                    clearInterval((this as any)._loginOtpTimer);
                    return { resendCountdown: 0 };
                }
                return { resendCountdown: next };
            });
        }, 1000);
        this.setState({ resendCountdown: seconds });
    }

    submitOtp = () => {
        if (!this.state.otpCode || this.state.otpCode.length !== 6) {
            this.setState({ otpError: 'Enter the 6-digit code.' });
            return;
        }
        this.setState({ isWaiting: true, otpError: '' });
        Request.verifyLoginOtp(this.state.email, this.state.otpCode,
            (ld) => {
                if (this.state.returnUrl) {
                    Tgcc.successfulCampusLogin(this.props.dispatch, ld, this.state.returnUrl);
                } else {
                    Tgcc.successfulCampusLogin(this.props.dispatch, ld);
                }
                this.setState({ isWaiting: false, showOtp: false, otpCode: '' });
            },
            (err: string) => this.setState({ isWaiting: false, otpError: err })
        );
    }

    resendOtp = () => {
        if ((this.state.resendCountdown || 0) > 0 || this.state.isResending) return;
        this.setState({ isResending: true, otpError: '' });
        Request.requestLoginOtp(this.state.email,
            (_res) => {
                const wait = _res && _res.resendAfterSeconds ? _res.resendAfterSeconds : 60;
                this.startResendCountdown(wait);
                this.setState({ isResending: false });
            },
            (err: string) => this.setState({ isResending: false, otpError: err })
        );
    }

    render(){
        var btnElement = this.state.isWaiting ? 
            Tgcc.workingGif
            : <div style={submitBtn} onClick={this.doLogin}>Submit</div>

        var errElement = this.state.error ? <div style={Tgcc.Styles.error}>{this.state.error}</div> : <div/>
        return(
            <div style={outerDiv}>
                <div id="campusLogin"></div>
                <div style={loginTop} onClick={this.openHome} className="loginTop">
                     <img src={Tgcc.ResolveUrl('~/images/2022Logo.png')} style={gcLogo}/>
                    <div style={loginTxt} className="campusLoginTxt">Login</div>
                </div>
                <div style={boxStyle} className="loginBoxStyle">
                    {errElement}
                    <div style={rowStyle}>
                        <div style={lblStyle}>Email</div>
                        <input autoFocus type='text' style={inputStyle} name='email' onChange={this.emailChanged} onKeyPress={this.keyPressed}/>
                    </div>
                    {btnElement}
                    <div style={bottomDiv} onClick={this.openRegister}>
                        <div style={newGC}>NEW TO THE GRAPHIC COW&#63;</div>
                        <div>
                            <div style={createAcc}>Create an Account</div>
                            <img src={Tgcc.ResolveUrl('~/images/arrow.png')} style={arrowStyle}/>
                        </div>
                    </div>
                </div>
                {this.state.showOtp && (
                    <div key="loginOtpOverlay" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}>
                        <div key="loginOtpDialog" style={{ background: '#fff', padding: '24px', borderRadius: '12px', width: '90%', maxWidth: '500px', boxShadow: '0 16px 40px rgba(0,0,0,0.2)', position: 'relative' }}>
                            <div key="closeX" onClick={() => this.setState({ showOtp: false })} style={{ position: 'absolute', right: 12, top: 10, cursor: 'pointer', fontSize: '20px', color: '#888' }}>×</div>
                            <h3 style={{ margin: '0 0 8px 0', fontFamily: 'Lulo', letterSpacing: '0.1em' }}>Enter your login code</h3>
                            <div style={{ color: '#555', marginBottom: '16px', lineHeight: '20px' }}>
                                We emailed a 6‑digit code to <strong>{(this.state.email || '').replace(/(.{2}).+(@)/, '$1***$2')}</strong>.
                            </div>
                            <input type="text" maxLength={6} aria-label="6-digit login code" value={this.state.otpCode} onChange={(e) => {
                                const v = (e.currentTarget && e.currentTarget.value) ? e.currentTarget.value : '';
                                this.setState({ otpCode: v.replace(/[^0-9]/g, '') });
                            }} onKeyPress={(e) => {
                                if (e.key === 'Enter' && this.state.otpCode && this.state.otpCode.length === 6) {
                                    this.submitOtp();
                                }
                            }} style={{ border: '1px solid #ccc', height: '48px', width: '100%', padding: '0 10px', fontSize: '26px', letterSpacing: '8px', textAlign: 'center', fontFamily: 'monospace', borderRadius: '6px' }} />
                            {this.state.otpError && <div style={{ color: 'red', marginTop: '8px', fontSize: '14px', fontWeight: 700, textAlign: 'center' }}>{this.state.otpError}</div>}
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '12px', width: '100%' }}>
                                <div>
                                    <button key="resend" onClick={this.resendOtp} disabled={(this.state.resendCountdown || 0) > 0 || !!this.state.isResending} style={{ border: 'none', background: 'transparent', color: '#3366cc', cursor: ((this.state.resendCountdown || 0) > 0 || !!this.state.isResending) ? 'default' : 'pointer', textDecoration: 'underline' }}>
                                        {this.state.isResending ? 'Resending…' : (this.state.resendCountdown && this.state.resendCountdown > 0 ? `Resend in ${this.state.resendCountdown}s` : 'Resend code')}
                                    </button>
                                </div>
                                <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                                    <div key="cancel" style={{ ...submitBtn, backgroundColor: '#777', whiteSpace: 'nowrap' }} onClick={() => this.setState({ showOtp: false })}>Cancel</div>
                                    <div key="verify" style={{ ...submitBtn, whiteSpace: 'nowrap', opacity: this.state.otpCode && this.state.otpCode.length === 6 ? 1 : 0.6, pointerEvents: this.state.otpCode && this.state.otpCode.length === 6 ? 'auto' : 'none' }} onClick={this.submitOtp}>Verify</div>
                                </div>
                            </div>
                            <div style={{ color: '#888', marginTop: '10px', fontSize: '12px' }}>Tip: Paste the whole code; numbers only.</div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state : Tgcc.GlobalState, ownState: any) => {
    return { state: state };
};

export var CampusLogin = connect(mapStateToProps)(Radium(_CampusLogin));